import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography, SxProps } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BLUE, WHITE } from '../utils/constants';
import { useAuth } from '../context/AuthContext';

const SignOut = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      logout();
      navigate('/login');
    }, 2000);
  }, [navigate]);

  return (
    <Box sx={outerBoxStyles}>
      <CircularProgress size={60} thickness={6} sx={progressStyles} />
      <Typography variant='h5' sx={textStyles}>
        Signing out...
      </Typography>
    </Box>
  );
};

export default SignOut;

const outerBoxStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  bgcolor: WHITE.light,
};

const progressStyles: SxProps = {
  mb: 2,
};

const textStyles: SxProps = {
  color: BLUE.dark,
};
